// this resizes the width of the uibTypeaheadPopup template to be the same width as the input box for typeahead (it won't automatically do this)
// and places it directly below the input box
// typeahead does the positioning (but not the width) automatically when it gets matches back for the query,
// but during the time we are showing the loading spinner instead of results, it won't be positioned correctly
// without this directive

// It will not mess with the width if you use the class ap-form-control-menu on the popup element,
// because this means that the width is already set to a percent that will be responsive
angular.module('aprima-core-ui').factory('positionTypeaheadPopup', ['$uibPosition', 'findTypeahead', '_', function ($uibPosition, findTypeahead, _) {
    'use strict';

    var ngHideClassRegex = /(\s|^)ng-hide(\s|$)/;

    return positionTypeaheadPopup;

    function positionTypeaheadPopup(popupScope, popupElement, typeaheadElement) {
        if(!popupScope || !popupElement) {
            return;
        }

        typeaheadElement = typeaheadElement || findTypeahead(popupElement);

        if(!typeaheadElement) {
            return;
        }

        var observer,
            watch,
            updatePosition;

        if(popupElement.hasClass('ap-form-control-menu')) {
            updatePosition = recalculatePosition;
        }
        else {
            updatePosition = updatePositionAndWidth;
        }

        if(MutationObserver){
            observer = new MutationObserver(function(mutations){
                var popupBecomingVisible = _.some(mutations, function(mutation) {
                    return ngHideClassRegex.test(mutation.oldValue) && !mutation.target.classList.contains('ng-hide');
                });

                if(popupBecomingVisible) {
                    updatePosition();
                }
            });

            observer.observe(popupElement[0], { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
        }
        else{
            watch = popupScope.$watch(function(){
                return !popupElement.hasClass('ng-hide');
            }, function(newVal){
                if(newVal){
                    updatePosition();
                }
            });
        }

        popupScope.$on('$destroy', function(){
            if(watch){
                watch();
            }

            if(observer){
                observer.disconnect();
            }
        });

        function updatePositionAndWidth(){
            recalculatePosition();

            popupElement.outerWidth(typeaheadElement.outerWidth());
        }

        // This is basically the same recalculatePosition function
        // that typeahead internally uses to position the results list correctly.
        // I modified it to set the style for left and top manually rather than
        // setting a scope variable, but the logic is the same
        function recalculatePosition() {
            var position = appendedToBody() ? $uibPosition.offset(typeaheadElement) : $uibPosition.position(typeaheadElement);
            position.top += typeaheadElement.prop('offsetHeight');

            popupElement.css('left', position.left);
            popupElement.css('top', position.top);
        }

        function appendedToBody() {
            return popupElement.parent().is('body');
        }
    }
}]);